export function fmt(v, f) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  switch (f) {
    case "currency":
      return "₹" + inr(v);
    case "number":
      return Number(v).toLocaleString("en-IN");
    case "percent":
      return `${round(v)}%`;
    case "hours":
      return `${Number(v).toLocaleString("en-IN")} h`;
    case "ratio":
      return `${round(v)}x`;
    default:
      return String(v);
  }
}

function round(v) {
  return Math.round(Number(v) * 10) / 10;
}

export function inr(v) {
  v = Number(v);
  if (Math.abs(v) >= 1e7) return (v / 1e7).toFixed(2) + " Cr";
  if (Math.abs(v) >= 1e5) return (v / 1e5).toFixed(2) + " L";
  return v.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export const RANGES = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "last_7_days", label: "Last 7 days" },
  { key: "last_30_days", label: "Last 30 days" },
  { key: "current_month", label: "Current month" },
  { key: "previous_month", label: "Previous month" },
  { key: "quarter", label: "Quarter" },
  { key: "year", label: "Year" },
];

export const CHART_COLORS = ["#6E3667", "#88D317", "#B07AA7", "#5AB0C9", "#E4A11B", "#A1A1AA", "#7BC015"];

export const sevColor = (s) =>
  ({
    critical: { dot: "bg-red-500", text: "text-red-600", bg: "bg-red-50", border: "border-red-200", chip: "bg-red-100 text-red-700" },
    warning: { dot: "bg-amber-500", text: "text-amber-600", bg: "bg-amber-50", border: "border-amber-200", chip: "bg-amber-100 text-amber-700" },
    opportunity: { dot: "bg-emerald-500", text: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", chip: "bg-emerald-100 text-emerald-700" },
    info: { dot: "bg-blue-500", text: "text-blue-600", bg: "bg-blue-50", border: "border-blue-200", chip: "bg-blue-100 text-blue-700" },
  }[s] || { dot: "bg-slate-400", text: "text-slate-600", bg: "bg-slate-50", border: "border-slate-200", chip: "bg-slate-100 text-slate-700" });
